import React, { FC } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  groupTitle: {
    color: '#8c8c8c',
    fontWeight: 700,
    padding: '8px 12px',
    borderRadius: '4px',
    whiteSpace: 'nowrap',
  },
}));

interface ISidebarGroupTitle {
  groupTitle: MessageDescriptor | string;
}

const SidebarGroupTitle: FC<ISidebarGroupTitle> = ({ groupTitle }) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Typography className={`sidebarGroupTitle ${classes.groupTitle}`}>
      {typeof groupTitle === 'string' ? groupTitle : intl.formatMessage(groupTitle)}
    </Typography>
  );
};

export default SidebarGroupTitle;
